import { TalentGraph } from '../models/dtos';
import ApiBase from './base/ApiBase';

export default class OverviewClient extends ApiBase {
  private controllerName: string = 'Overview';

  async GetAssessorTalentOverview(signal?: AbortSignal): Promise<DashboardCard[]> {
    return this.GetAsync(`${this.controllerName}`, signal);
  }
}

export interface DashboardCard {
  TalentId: string;
  FullName: string;
  EmailForAvatar: string;
  PositionTitle: string;
  NotesCount: number;
  NotesInPeriodCount: number;
  EventsCount: number;
  EventsPositiveCount: number;
  EventsNegativeCount: number;
  OpenPerformanceItemCount: number;
  OpenPerformanceItemHighCount: number;
  OpenPerformanceItemMediumCount: number;
  OpenPerformanceItemLowCount: number;
  CurrentAssessmentTotalCount: number;
  CurrentAssessmentCompletedCount: number;
  CurrentAssessmentPercentComplete: number;
  CurrentAssessmentScore: number;
  DevelopmentPlanActiveCount: number;
  DevelopmentPlanCompletedCount: number;
  DevelopmentPlanTotalCount: number;
  DevelopmentPlanStatus: string;
  LastAssessmentScore: number;
  LastAssessmentDate: string | null;
  ReviewStatus: string;
  ReviewPeriodStart: string | null;
  ReviewPeriodEnd: string | null;
}

export enum OverviewErrors {
  AssessorOvervidw = 'Error loading dashboard data.'
}
